import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import { Routes, Route, useLocation } from 'react-router-dom';

import AppBar from './components/AppBar';
import Hero from './components/Hero';
import Features from './components/Features';
import Integrations from './components/Integrations';
import Roadmap from './components/Roadmap';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import About from './components/About';
import Careers from './pages/Careers';
import AppTheme from './shared-theme/AppTheme';
import { useColorScheme } from '@mui/material/styles';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import { Tokenomics } from './components/Tokenomics';

export default function App(props: { disableCustomTheme?: boolean }) {
  const { mode, setMode } = useColorScheme();
  const location = useLocation();
  
  if (mode !== 'dark') {
    setMode('dark')
  }

  const isAuthPage = location.pathname.startsWith('/auth/');

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {!isAuthPage && <AppBar />}
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <div>
                <About />
                <Divider />
                <Features />
                <Divider />
                <Integrations />
                <Divider />
                <Roadmap />
                <Divider />
                {/* <Tokenomics /> */}
                <Divider />
                <FAQ />
                <Footer />
              </div>
            </>
          }
        />
        <Route path="/careers" element={<Careers />} />
        <Route path="/auth/login" element={<SignIn />} />
        <Route path="/auth/register" element={<SignUp />} />
      </Routes>
    </AppTheme>
  );
}